export default __webpack_public_path__ + "nunito-sans-v11-latin-regular.woff2";